"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppDBDocumentFilterMethod = void 0;
var AppDBDocumentFilterMethod;
(function (AppDBDocumentFilterMethod) {
    AppDBDocumentFilterMethod["Read"] = "READ";
    AppDBDocumentFilterMethod["Update"] = "UPDATE";
    AppDBDocumentFilterMethod["Delete"] = "DELETE";
})(AppDBDocumentFilterMethod = exports.AppDBDocumentFilterMethod || (exports.AppDBDocumentFilterMethod = {}));
